import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
} from '@mui/material';
import ButtonBox from '../../components/ButtonBox';
import ThingConfig from '../../components/ThingConfig';
import useThingStore from '../../stores/ThingStore';
import ThingApi from '../../api/ThingApi';
import { ThingConfigType, ThingKey } from '../../types/ThingType';
import { getRandomId, isArray, isJSON, useError } from '../../utils/functions';
import DialogBox from '../../components/DialogBox';

const ThingConfiguration: React.FC = () => {
  const { setError } = useError();
  const [open, setOpen] = useState(false);


  const { thingObj, labelConfigs, setLabelConfigs } = useThingStore();

  const getConfig = async () => {
    if (thingObj.id) {
      const res = await ThingApi.listConfigs(thingObj.id);

      if (res && res.data && res.data.length > 0) {
        const newConfigs = [];
        for (let data of res.data) {
          const dataKeys = [];
          if (data.configs && data.configs.length > 0) {
            for (let key of data.configs) {
              let editValueType = '';
              let value = '';
              if (typeof key.expectedValue === "string") {
                editValueType = 'string';
                value = key.expectedValue;
              } else if (typeof key.expectedValue === "number") {
                editValueType = 'number';
                value = key.expectedValue.toString();
              } else if (typeof key.expectedValue === "boolean") {
                editValueType = 'boolean';
                value = key.expectedValue.toString();
              } else if (Array.isArray(key.expectedValue)) {
                editValueType = 'Array';
                value = JSON.stringify(key.expectedValue);
              } else if (key.expectedValue instanceof Object) {
                editValueType = 'JSON';
                value = JSON.stringify(key.expectedValue);
              }

              const newKey: ThingKey = {
                viewKeyId: getRandomId(),
                key: key.key,
                value: value,
                valueType: editValueType,
              };

              dataKeys.push(newKey);
            }
          }

          const newConfig: ThingConfigType = {
            name: data.name,
            viewId: data.name,
            dataKeys: dataKeys
          };

          newConfigs.push(newConfig);
        }

        setLabelConfigs(newConfigs);
      } if (res.code) {
        setError(res.message);
      }
    }

  };

  const handleUpdate = async () => {
    if (thingObj.id) {
      let hasErr = false;
      let validateTypeFail = false;
      for (let config of labelConfigs) {
        const name = config.name;
        const configs = {
          configs: config.dataKeys.reduce((obj: { [key: string]: any }, { key, value, valueType }) => {
            if (valueType === "JSON") {
              if (isJSON(value)) {
                obj[key] = JSON.parse(value);
              } else {
                validateTypeFail = true;
                hasErr = true;
              }
            } else if (valueType === "Array") {
              if (isArray(value)) {
                obj[key] = JSON.parse(value);
              } else {
                validateTypeFail = true;
                hasErr = true;
              }
            } else if (valueType === "string") {
              obj[key] = value;
            } else if (valueType === "boolean") {
              obj[key] = (value === "true");
            } else if (valueType === "number") {
              obj[key] = Number(value);
            }
            return obj;
          }, {})
        };

        if (!validateTypeFail) {
          const res = await ThingApi.createUpdateConfig(thingObj.id, name, configs);
          if (res.code) {
            setError(res.message);
            hasErr = true;
            break;
          }
        }
      }

      if (validateTypeFail) {
        setError('JSON/Array Type Error.');
      }

      if (!hasErr) {
        setOpen(true);
      }
    }

  }

  useEffect(() => {
    getConfig();
  }, []);

  return (
    <Box>
      <Typography className="layout-title">
        Configuration
      </Typography>

      <Box sx={{ padding: 2 }}>
        <ThingConfig />

        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
          <ButtonBox
            variant="contained"
            text="Send"
            onClick={handleUpdate} />
        </Box>
      </Box>
      <DialogBox
        open={open}
        title='Success'
        dialogContent={
          <>
            Send success.
          </>
        }
        showCancel={false}
        onCancel={() => setOpen(false)}
        onConfirm={() => setOpen(false)}
        confirmLabel='OK'
      />

    </Box>

  );
};

export default ThingConfiguration;
